'use client';

function logError(errMsg, errDetails) {
  console.error(errMsg, errDetails ?? "");
}
export {
  logError
};
